module.exports = __webpack_public_path__ + "static/media/eagle1.af4e96ac.png";